import  { useEffect, useState } from "react";
import Cookies from 'js-cookie'; 
export async function creatpassowrd() {
 const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL ; 
// localStorage.clear();
   const Checkuserexistandsendmail = async (EmailId:string) => {
     const data = { emailId: EmailId };
 
     try {
        const response = await fetch(`${API_BASE_URL}/Account/ForgotPassword/CheckEmailAndSendMail`, {
          method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify(data),
       });
 
       if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`); 
       }  
       const userdetails = await response.json();
      console.error("Login failed:", userdetails);
        return userdetails;
     } catch (err) {
       console.error("Error loading templates:", err);
     }
     
   }; 
    const CreatenewPassowrd= async (NewPassword:string,ConfirmNewPassword:string,Otp:string,ResetToken:string)=> 
    { 
   const data = {
    NewPassword: NewPassword,
    ConfirmPassword: ConfirmNewPassword,
    Otp: Otp,
    ResetToken: ResetToken
};

try {
    const response = await fetch(`${API_BASE_URL}/Account/ForgotPassword/ResetUserPassword`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });

    const result = await response.json();
     return result;

} catch (error) {
    console.error("Error:", error);
}

  };
return {
    Checkuserexistandsendmail ,
    CreatenewPassowrd
  };
}